<ng-template #dialog>
    <ng-container *ngTemplateOutlet="contentTemplate" />

    @if (closeButton) {
        <app-icon class="close-icon" [mat-dialog-close] name="close" />
    }
</ng-template>
